import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "facet-values-range" }
const _hoisted_2 = { class: "facet-values-range__name" }

import { FacetHit } from '@/composables/useDynamicProductListing';

import FacetRangeControl from './FacetRangeControl.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'FacetValuesRange',
  props: {
    facet: null
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(FacetRangeControl, { facet: __props.facet }, {
      "facet-name": _withCtx(() => [
        _createElementVNode("div", _hoisted_2, _toDisplayString(__props.facet.name), 1)
      ]),
      _: 1
    }, 8, ["facet"])
  ]))
}
}

})